import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fields", "title", "description", "TitleRowProps", "TitleColProps", "TitleProps", "DescriptionColProps", "DescriptionProps", "DescriptionRowProps", "RowProps", "ColProps", "component", "name"];
import React from 'react';
import PropTypes from 'prop-types';
import Typography from "antd/es/typography/index.js";
import Row from "antd/es/row/index.js";
import Col from "antd/es/col/index.js";
import useFormApi from "@data-driven-forms/react-form-renderer/use-form-api";
var Title = Typography.Title,
    Paragraph = Typography.Paragraph;

var SubForm = function SubForm(_ref) {
  var fields = _ref.fields,
      title = _ref.title,
      description = _ref.description,
      TitleRowProps = _ref.TitleRowProps,
      TitleColProps = _ref.TitleColProps,
      TitleProps = _ref.TitleProps,
      DescriptionColProps = _ref.DescriptionColProps,
      DescriptionProps = _ref.DescriptionProps,
      DescriptionRowProps = _ref.DescriptionRowProps,
      RowProps = _ref.RowProps,
      ColProps = _ref.ColProps,
      component = _ref.component,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFormApi = useFormApi(),
      renderForm = _useFormApi.renderForm;

  return /*#__PURE__*/React.createElement("div", rest, title && /*#__PURE__*/React.createElement(Row, TitleRowProps, /*#__PURE__*/React.createElement(Col, _extends({
    span: 24
  }, TitleColProps), /*#__PURE__*/React.createElement(Title, _extends({
    level: 3
  }, TitleProps), title))), description && /*#__PURE__*/React.createElement(Row, DescriptionRowProps, /*#__PURE__*/React.createElement(Col, _extends({
    span: 24
  }, DescriptionColProps), /*#__PURE__*/React.createElement(Paragraph, DescriptionProps, description))), /*#__PURE__*/React.createElement(Row, RowProps, /*#__PURE__*/React.createElement(Col, _extends({
    span: 24
  }, ColProps), renderForm(fields))));
};

SubForm.propTypes = {
  fields: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  TitleRowProps: PropTypes.object,
  TitleColProps: PropTypes.object,
  TitleProps: PropTypes.object,
  DescriptionColProps: PropTypes.object,
  DescriptionProps: PropTypes.object,
  DescriptionRowProps: PropTypes.object,
  RowProps: PropTypes.object,
  ColProps: PropTypes.object,
  component: PropTypes.string,
  name: PropTypes.string
};
export default SubForm;